import React from 'react';
import UrlLink from '../../../components/UI/UrlLink/UrlLink';
import classes from './HandlingUserData.module.css';
import paths from '../../../constants/paths';

import { QUERY_PARAM_DELETE_ACCOUNT } from '../../../containers/ContactUs/ContactUsContainer';

const en = (props) => (
  <div className={classes.Content}>
    {props.indexPage && (
      <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}>
          <b>Download Data</b>
        </p>
        <p>
          To download your data go to the following page
          <br />
          Settings {'>'} Options {'>'} Data Management {'>'} Download Data
        </p>
        <br />
        <div className={classes.HrLine} />
        <br />
      </div>
    )}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}>
      <b>Request Data Deletion</b>
    </p>
    <br />
    <p>To request data deletion, follow the steps below:</p>
    <br />
    <p>
      1. Go to{' '}
      <UrlLink
        to={`${
          props.indexPage ? paths.CONTACT_US : paths.SETTINGS__CONTACT_US
        }?${QUERY_PARAM_DELETE_ACCOUNT}`}
      >
        Contact Us Page
      </UrlLink>
      <br />
      2. Select option "Delete Account And All My Data" <br />
      3. Fill in form and press "Send Message" <br />
      <br />
    </p>
  </div>
);

export default en;
